import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { NewProfile } from "../types/Types";

/**
 * @author noone
 */

export type AuthCreateAccountState = {
    profile: NewProfile,
}

const initialState = {
    profile: {},

} as AuthCreateAccountState;

const authCreateAccountSlice = createSlice({
    name: 'authCreate',
    initialState: initialState,
    reducers: {
        setProfile(state, action: PayloadAction<NewProfile>) {
            state.profile = action.payload;
        },
        setEmail(state, action: PayloadAction<string>) {
            state.profile.email = action.payload;
        },
        setPassWord(state, action: PayloadAction<string>) {
            state.profile.password = action.payload;
        },
        setCompleteProfileValues(state, action: PayloadAction<AuthCreateAccountState>) {
            return state = action.payload;
        }
        
    }
});

export const { 
     setProfile
     , setPassWord
     , setEmail
     , setCompleteProfileValues
} = authCreateAccountSlice.actions;

export default authCreateAccountSlice;


